#!/usr/bin/env node
// Entry point for the published CLI binary
// Note: Using ESM import with .js extension so it runs correctly after build.
import "../main.js";
